import { uploadFile } from '@tencent/pmd-vue/lib/upload-file';
import { isTestEnv } from '@tencent/pmd-tools/lib/env';

export function uploadImage(data, callback, needCrop = false) {
  const url = isTestEnv()
    ? 'https://api-test.nes.smoba.qq.com/tipmp.tools_gz.cos_mgr_cgi.cos_mgr_cgi/Upload2Cos'
    : 'https://api.nes.smoba.qq.com/tipmp.tools_gz.cos_mgr_cgi.cos_mgr_cgi/Upload2Cos';
  uploadFile({
    sceneId: isTestEnv() ? 'test' : 'saibao',
    fileExt: needCrop ? 'png' : 'jpg',
    base64Encode: needCrop,
    url,
    data,
  }).then((res) => {
    if (res?.url) {
      callback(res);
    } else {
      callback({ msg: 'upload failed' });
    }
  })
    .catch((err) => {
      callback({ msg: `upload err: ${err}` });
    });
}
